import { useState } from 'react';
import FormWrapper from '../../Reusable/FormWrapper/FormWrapper';
import InputField from '../../Reusable/InputField';
import { basicFormValidationHandler } from '../../../utils';
import { isEmpty } from 'lodash';
import { emailPattern } from '../../../constants/globals';

const ContactForm = (props) => {
  const { submitRef, translations, onSubmit } = props || {},
    { Placeholders, HelperText, Errors } = translations || {};
  const [email, setEmail] = useState(null);
  const [errors, setErrors] = useState({});

  const onChangeHandler = (event) => {
    setEmail(event?.target?.value);
  };

  const clientValidation = () => {
    const errorsObject = basicFormValidationHandler({ email }, Errors);
    if (email && !emailPattern.test(email)) {
      errorsObject['email'] = Errors.emailPattern;
    }
    setErrors(errorsObject);
    return !isEmpty(errorsObject);
  };

  const onSubmitHandler = (e) => {
    e.preventDefault();
    if (clientValidation()) return;
    onSubmit(email);
  };

  return (
    <FormWrapper
      submitRef={submitRef}
      noValidate={true}
      onSubmit={onSubmitHandler}
    >
      <InputField
        id="email"
        name="email"
        type="email"
        placeholder={Placeholders?.email}
        onChange={onChangeHandler}
        value={email}
        error={errors}
        errorsHandler={setErrors}
        required
        autoFocus={true}
        helperText={HelperText?.info}
      />
    </FormWrapper>
  );
};

export default ContactForm;
